<template>
  <div class="action-button-container" :class="classes">
    <padding full-width>
      <icon-button v-if="iconOnly"
                   :size="size"
                   :icon="icon"
                   no-hover-state
                   full-width
                   @click="clickHandler"
                   @mouseenter="mouseenterHandler"
                   @mouseleave="mouseleaveHandler"/>
      <Button v-else
              :size="size"
              :icon="icon"
              :icon-align-right="active"
              :nowrap="nowrap"
              no-hover-state
              full-width
              :disabled="disabled || processing"
              @click="clickHandler"
              @mouseenter="mouseenterHandler"
              @mouseleave="mouseleaveHandler">
        <slot/>
      </Button>
    </padding>
  </div>
</template>

<script>
import buttonComponentMixin from '../../mixins/buttonComponentMixin'
import Padding from '../Utils/Padding'
import Button from './Button'
import IconButton from './IconButton'

export default {
  name: 'ActionButton',
  components: { IconButton, Button, Padding },
  mixins: [buttonComponentMixin],
  data() {
    return {
      hover: false,
      processing: false,
    }
  },
  props: {
    icon: {
      type: String,
      required: false,
      default: '',
    },
    iconAlignRight: {
      type: Boolean,
      required: false,
      default: false,
    },
    active: {
      type: Boolean,
      required: false,
      default: true,
    },
    borderRadiusRight: {
      type: Boolean,
      required: false,
      default: false,
    },
    iconOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    contrast: {
      type: Boolean,
      required: false,
      default: false,
    },
    asyncSubmit: {
      type: Boolean,
      required: false,
      default: false,
    },
    fullHeight: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    classes() {
      let classes = `action-button-container--${this.colour}`

      if (this.hover) {
        classes = `${classes} action-button-container--hover`
      }
      if (this.active) {
        classes = `${classes} action-button-container--active`
      } else {
        classes = `${classes} action-button-container--inactive`
      }
      if (this.borderRadiusRight) {
        classes = `${classes} action-button-container--border-radius-right`
      }
      if (this.contrast) {
        classes = `${classes} action-button-container--high-contrast`
      }
      if (this.processing) {
        classes = `${classes} action-button-container--processing`
      }
      if (this.fullHeight) {
        classes = `${classes} action-button-container--full-height`
      }

      return classes
    },
  },
  methods: {
    mouseenterHandler(event) {
      this.hover = true
      this.$emit('mouseenter', event)
    },
    mouseleaveHandler(event) {
      this.hover = false
      this.$emit('mouseleave', event)
    },
    clickHandler() {
      if (this.asyncSubmit) {
        this.processing = true

        const promise = new Promise((resolve, reject) => {
          this.$emit('click', { resolve, reject })
        })

        promise.then(() => {
          this.processing = false
        })
      } else {
        this.$emit('click')
      }
    },
  },
}
</script>
